<template>
  <div>
    <div v-if="userIsAParent">
      <badges-locked-list-parent :badges="badges" />
    </div>
    <div v-else>
      <badges-locked-list-child :badges="badges" />
    </div>
  </div>
</template>
<script>
import { useSessionStore } from '@/common';
import BadgesLockedListParent from '@/gamification/components/BadgesLockedListParent';
import BadgesLockedListChild from '@/gamification/components/BadgesLockedListChild';

export default {
  components: {
    BadgesLockedListParent,
    BadgesLockedListChild,
  },
  props: {
    badges: Array,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
  },
};
</script>
<style lang="scss">
.badge-item {
  flex-wrap: nowrap;
  align-items: center;
  gap: 1em;

  .badge-image {
    width: 160px;
    height: 95px;
    object-fit: contain;
  }

  .badge-info {
    background-color: transparent;
    color: black;
    padding: 15px;
    flex-grow: 1;

    .badge-title {
      color: #163282;
      width: 100%;
      font-size: calc(0.7vw + 0.5rem);
    }

    .badge-progress {
      display: flex;
      flex-direction: column;
      width: 100%;

      .progress-text {
        font-size: 0.7rem;
        font-weight: 600;
        margin-left: auto;
      }

      .progress {
        height: 5px;
      }
      .progress-parent {
        height: 8px;
      }
    }
  }
}
</style>

